import { useQuery } from 'react-query';
import toastr from 'react-hot-toast';
import React from 'react';
import { fetchWrapper } from 'utils/fetchWrapper';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { DropdownOption } from 'types/common/DropdownOption';
import { alphabeticalSort } from 'utilities/sort';
import { generateURL } from 'utilities/hooks/urlGeneration';

type Gender = {
  id: string;
  attributes: { name: string; sortOrder: number };
};
type GenderResponse = {
  data: Gender[];
};
const getGenders = () => {
  const url = generateURL(SPARK_RESOURCE_TYPES.GENDERS, []);
  return fetchWrapper<GenderResponse>({
    url: url,
    method: 'GET',
  });
};

export function useGetGenders() {
  const queryResult = useQuery(['genders'], getGenders, {
    onError: (error) => {
      if (error instanceof Error) {
        toastr.error(`Failed to get Genders: ${error.message}`);
      }
    },
  });

  const { data } = queryResult;
  const { data: genders } = data || {};

  const sortedGenders = genders?.sort((a, b) => {
    return a.attributes.sortOrder === b.attributes.sortOrder
      ? alphabeticalSort(a.attributes.name, b.attributes.name)
      : a.attributes.sortOrder - b.attributes.sortOrder;
  });

  const dropdownOptions: DropdownOption[] =
    React.useMemo(
      () =>
        sortedGenders?.map((gender) => ({
          label: gender.attributes.name,
          value: gender.id,
        })),
      [sortedGenders]
    ) || [];

  return {
    dropdownOptions,
    genders: sortedGenders,
    ...queryResult,
  };
}
